import $ from "@modules/jquery";


function adjustFooterItemFun() {

    let maxheight_1 = 0;
    let maxheight_2 = 0;
    let maxheight_3 = 0;

    var footerItemLevel_1 = $('.footer-item-level-1');
    var footerItemLevel_2 = $('.footer-item-level-2');
    var footerItemLevel_3 = $('.footer-item-level-3');

    // Find the maximum height
    footerItemLevel_1.each(function () {
        let elementHeight = $(this).height();
        if (elementHeight > maxheight_1) {
            maxheight_1 = elementHeight;
        }
    });

    // Find the maximum height
    footerItemLevel_2.each(function () {
        let elementHeight = $(this).height();
        if (elementHeight > maxheight_2) {
            maxheight_2 = elementHeight;
        }
    });

    // Find the maximum height
    footerItemLevel_3.each(function () {
        let elementHeight = $(this).height();
        if (elementHeight > maxheight_3) {
            maxheight_3 = elementHeight;
        }
    });

    if ($(window).width() > 640) {
        // Set all elements to the maximum height
        footerItemLevel_1.height(maxheight_1);
        footerItemLevel_2.height(maxheight_2);
        footerItemLevel_2.height(maxheight_2);
    } else {
        footerItemLevel_1.height('auto');
        footerItemLevel_2.height('auto');
        footerItemLevel_2.height('auto');
    }
};

export default () => {
    $(window).on("resize", () => {
        adjustFooterItemFun();
    })
    adjustFooterItemFun();
};